import { Suspense } from 'react'
import { colors } from '@lmc/common/constants'
import Field from '../../../fields'

interface HomelyRemedyFieldProps {
  confirmProps: Record<string, any>
  fields: Record<string, any>
  formId: string
  onConfirm: (key: string, value: any) => void
  requireConfirm: boolean
  testId?: string
}

/**
 * @description Renders HomelyRemedyField for the Add Medication modal
 * @param {HomelyRemedyFieldProps} props - The component's props.
 * @returns {JSX.Element} HomelyRemedyField.
 */
export default function HomelyRemedyField(
  props: HomelyRemedyFieldProps
): JSX.Element {
  const { confirmProps, fields, formId, onConfirm, requireConfirm, testId } =
    props

  const title = 'Homely Remedy'

  const selectedOptionFieldStyle = requireConfirm ? styles.prepopField : null

  return (
    <div
      style={styles.userGeneratedFieldContainer}
      data-testid={
        testId ? `${testId}-homely-remedy-field` : 'homely-remedy-field'
      }
    >
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          compact
          confirmProps={confirmProps}
          displayLabel
          fieldType="radios"
          formId={formId}
          hasComment
          helpLink="https://www.cqc.org.uk/guidance-providers/adult-social-care/over-counter-medicines-homely-remedies"
          helpText="OTC and homely remedies"
          keys="homeRemedy"
          label={title}
          layout="no-label"
          onConfirm={onConfirm}
          options={DEFAULT_RADIO_OPTIONS}
          requireConfirm={requireConfirm}
          required
          selectedOptionFieldStyle={selectedOptionFieldStyle}
          type="userGeneratedFieldLayout"
          values={fields}
          data-testid={
            testId
              ? `${testId}-homely-remedy-field-input`
              : 'homely-remedy-field-input'
          }
        />
      </Suspense>
    </div>
  )
}

const DEFAULT_RADIO_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' }
]

const styles = {
  prepopField: {
    background: colors.hoverblue
  },
  userGeneratedFieldContainer: {
    marginBottom: 16
  }
}
